import { useGetProjectsQuery } from '@/slices/projectSlice';

const useOpportunities = ({ _customer, skip } = { _customer: '', skip: false }) => {
	const { opportunities, isLoading, isError } = useGetProjectsQuery(
		undefined,
		{
			skip,
			selectFromResult: ({ data, isLoading, isError }) => {
				const opportunities = data?.ids
					?.map((id) => data.entities[id]) // Map ids to project objects
					.filter((project) => project.opportunity) // Filter projects with an opportunity
					.filter((project) => {
						if (!_customer) return true;

						return project._customer === _customer;
					}) // Filter by customer if _customer is passed
					.map((project) => {
						return {
							...project.opportunity,
							number: project.number,
							customer: project.customer,
							_project: project._id,
							type: 'opportunity',
						};
					}); // Extract opportunities
				return { opportunities, isLoading, isError };
			},
		}
	);

	return { opportunities, isLoading, isError };
};

export default useOpportunities;
